import React from 'react'
import Helmet from 'react-helmet'
import { Link } from 'react-router-dom'
import './style.css'


const About = () => (
  <div className='about'>
    <Helmet title='About Us' />
    <div id='insidebanner'>
      <img src='/_ima/about-us.png' alt='About Appko' />
    </div>
    <div id='content'>
      <div id='content-block'>
        <div className='first article'>
          <h1>The Appko Story</h1>
          <p>
            Every entrepreneur with a Silicon Valley dream wants to
            build a product like Snapchat, PayPal or Amazon....
            Appko wanted to build a new cloud.
            Back in 2007, 3 young and ambitious partners had a big
            dream to build a new way of computing in Silicon Valley.
            Going through ups and downs, step by step they struggled
            for something they believed in.
          </p>
          <p>
            And what was the most important thing we’ve learned on
            our way?
          </p>
          <p>
            Neither the large budgets nor the competitive technical
            excellence could make your product succeed. People
            could. Throughout the years our main goal is to build the
            best team ever, attracting not just coders but exceptional
            talents. Those who dream big, continue to evolve, and
            care about the outcomes.
            In 2012 Cisco invited our core team to be a part of their
            Cloud Development Team. That was a start of a super
            productive cooperation, that has been lasting for more
            than 7 years now.
          </p>
          <p>
            So what's the Appko secret for building teams?
          </p>
          <p>
            Our main secret weapon is focus. We don’t try to be all
            things for all situations, instead our only goal is to
             bringthe most talented developers in CIS to where our clients
            need them.
          </p>
          <p>
            Founded in 2007, Appko has been in business more than a decade and have maintained
            profitability every year.
            <Link to='?Appko_Accolade'> Appko </Link>
            is debt free.
          </p>
        </div>
        <div className='img-story'>
          <img src='/_ima/our-history.jpg' alt='Appko team' />
        </div>
      </div>
      <div className='second article'>
        <h1>Appko Advantage</h1>
        <h3>Market Insights</h3>
        <p>
          We love making friends, we build bridges, we value relationships. That’s why
          we have subject matter expertise and key relationships with the hottest companies
          in the bay area market. With insights into the hiring engineers, we do understand
          the current conditions for talent and we have the opportunity to share this expertise
          with our Clients. With us behind they can adjust accordingly with their hiring
          process.
        </p>
        <h3>Offerings based on Analysis</h3>
        <p>
          Appko’s market insights create an opportunity to provide unique offerings to
          address the current conditions with skilled engineers and services.
        </p>
        <h3>24 Working Hours Coverage Per Day</h3>
        <p>
         Time difference can benefit your teams productivity. Wake up and see your
          team’s accomplishments while you’ve slept. Much more convenient shared working
          hours compared to the other low cost outsourcing destinations gives the CIS
          countries the competitive edge. Highly collaborative model, which aligns well with
          Agile development methodology.
        </p>
        <Link to='?Appko_Accolade'><h3>Talented Developers</h3></Link>
        <p>
         We’re not just saying we have “the best, the most creative, and the most
          loyal people in the whole world”. The truth is - we are proud to have the great guys
          with innovative minds and high dedication. Throughout the years they have proven
          to be highly professional, receiving dozens of feedbacks from our Clients. How did
          we achieve that? The answer is simple - we appreciate each and every talent we
          have in our team. We care about them, we listen to their needs.
        </p>
        <h3>Innovative Approach</h3>
        <p>
          No need to spend time setting up and conducting an Interview. Along with
          the Candidate’s Resume our Clients receive a video of Candidate working on a real
          project. The Client can check the clean code and overall skills of desired Candidate
          even before the Interview.
        </p>
        <Link to='?Appko_and_CIS'><h3>Regional Advantage</h3></Link>
        <p>
          Appko has worked with engineers from all over the country, and all over the
          world. We have discovered where the talent lies and how to entice them with
          challenging engagements.
          We have found a fantastic talent base in
          <Link to='?Appko_and_CIS'> Eastern Europe</Link>
          , as well as incredible individuals here at home.
        </p>
      </div>
      <div className='third article'>
        <div className='block-content'>
          <h1>Appko Global</h1>
          <p>
            Appko has two offices and multiple legal entities covering Silicon Valley and
            <Link to='?Appko_and_CIS'> Eastern Europe</Link>
            .
          </p>
        </div>
        <div className='location'>
          <h4>Appko Inc</h4>
          <p>Silicon Valley</p>
          <h4>Appko CIS Office</h4>
          <p>Kyiv, Ukraine</p>
          <h4>Satellite location</h4>
          <p>Almaty, Kazakhstan</p>
        </div>
        <div>
          <img src='/_ima/map_2.png' alt='map' />
        </div>
      </div>
      <div className='fourth article'>
        <h1>Our Leadership Team</h1>
        <p>
            The Appko team has decades of combined experience leading service companies and organizations in
            the Silicon Valley and across the world. Appko’s 10+ years on the market has brought together the most
            talented and dedicated developers to help our clients with their software development needs and
            challenges. The team of Front-End, Back-End, DevOps and Cloud developers are doing their best to build
            innovative solutions and bring value to the market.
        </p>
        <img className='management' src='/_ima/sean-moreland.png' alt='Sean Moreland' />
        <h4>Sean Moreland, President</h4>
        <a
          className='linkedin-link'
          href='https://www.linkedin.com/in/seanmoreland/'
          target='_blank'
          rel='noopener noreferrer'
        >
          Linkedin Profile
        </a>
        <ul>
          <li>
            Why Appko? Nothing like seeing our customers succeed and smile because of our talented
            people. Its awesome when our
            <Link to='?Appko_Accolade'>
              <strong> customers talk about Appko people...</strong>
            </Link>
          </li>
          <li>
              Responsible: Customer success and providing high impact value to Appko’s customers on a daily
              basis. Providing customers with A+ technical solutions, people, and teams which will allow our
              customers WIN in their perspective industries and markets. (sales, software engineering,
              delivery, recruitment, and marketing)
          </li>
          <li>
              10+ years at Appko Inc. as President and Founder
          </li>
          <li>
              Technical expertise: Software development and engineering, ERP, CRM, and Cloud
          </li>
          <li>
              Customers: Fortune 500 companies as Google, Nest, IBM, AMD, Global Foundries, Lenovo,
              PayPal, John Deere, Sony, Disney, Abbott Vascular, Cisco, Avnet and the U.S. Army
          </li>
          <li>
              Hobbies/Fun: Walking the Camino de Santiago from (Urdos France) to the end of the world
              (Finesstera, Spain), Family First, and when time left over :) Golf, Trail Running, Surfing, and
              Exploring the world.
          </li>
        </ul>
        <img className='management' src='/_ima/tony-moreland.png' alt='Tony Moreland' />
        <h4>Tony Moreland, COO / Managing Partner</h4>
        <a
          className='linkedin-link'
          href='https://www.linkedin.com/in/tony-moreland-82b7a3/'
          target='_blank'
          rel='noopener noreferrer'
        >
          Linkedin Profile
        </a>
        <ul>
          <li>
             Why Appko - Surrounded by talented people, technology, and customers.
          </li>
          <li>
              Responsible for Business Development, Sales and Operations for Appko (COO)
          </li>
          <li>
              20+ Years in Leadership roles, Services, Operations, Engineering and Sales
          </li>
          <li>
              15 years at Cisco Systems leading Service organizations supporting Sprint, Verizon, AT&T, and
              some of the largest Enterprise companies worldwide
          </li>
          <li>
              3 Start up companies in various industries; Energy, Communications and Cloud
          </li>
          <li>
              Technical expertise in Networking, Data Center, Wireless, Security technologies, Cloud
              computing and Software Engineering delivery
          </li>
          <li>
              Language Fluency in English and Spanish
          </li>
          <li>
                Hobbies: Running, Golf, and Coach - Softball, Baseball and Basketball
          </li>
        </ul>
        <img className='management' src='/_ima/sean-dulac.png' alt='Sean DuLac' />
        <h4>Sean DuLac, Chief Executive Officer</h4>
        <a
          className='linkedin-link'
          href='https://www.linkedin.com/in/seandulac/'
          target='_blank'
          rel='noopener noreferrer'
        >
          Linkedin Profile
        </a>
        <ul>
          <li>
              Spent first part of his career as a developer in Silicon Valley for Nokia
          </li>
          <li>
              Moved into management of development team at Apple
          </li>
          <li>
              20+ years in Silicon Valley working in software engineering
          </li>
          <li>
              Started two profitable startup companies prior to Appko
          </li>
          <li>
              Ran consulting firm for fortune 1000 companies delivering large budget initiatives on time
          </li>
          <li>
              Well versed in all aspects of technology, created multiple products including hardware and
              software
          </li>
          <li>
                Solid business executive running small consulting firms profitably since 2002
          </li>
          <li>
                Hobbies: Travel, technology, culture, and people.
          </li>
        </ul>
        <p>
            Combining application development skills with consulting service business experience, Mr Dulac has
            honed his ability to identify top talent in engineering and bring those people to where they are needed.
        </p>
        <a
          className='vimeo-link'
          href='https://vimeo.com/16236112'
          target='_blank'
          rel='noopener noreferrer'
        >
          See Sean Dulac Launching Appko at Oracle Open World 2010
        </a>
      </div>
    </div>
  </div>
)

export default About
